import { ListBoxItem } from "@jugl-web/ui-kit";
import { useMemo } from "react";

export const useInvoiceFormOptions = ({ currency }: { currency: string }) => {
  const discountUnits = useMemo<ListBoxItem<string>[]>(
    () => [
      {
        id: "percentage",
        value: "%",
      },
      {
        id: "value",
        value: currency.toUpperCase(),
      },
    ],
    [currency]
  );

  const taxUnits = useMemo<ListBoxItem<string>[]>(
    () => [
      {
        id: "percentage",
        value: "%",
      },
      // {
      //   id: "currency",
      //   value: currency.toUpperCase(),
      // },
    ],
    []
  );

  return { discountUnits, taxUnits };
};
